import { ExclamationCircleOutlined } from "@ant-design/icons";
import DatePicker from "../../../../../components/inputs/MomentDatePicker";
import { Button, Checkbox, Form, Input, message, Modal, Select, Tag, Typography } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { BsPencil } from "react-icons/bs";
import { useQuery, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { serverUrl } from "../../../../../nestserver";
import { numberInputGuard } from "../../../../../components/inputs/numberInputGuard";
const { Option } = Select;

function tagRender(props) {
  const { label, closable, onClose } = props;
  const onPreventMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <Tag
      onMouseDown={onPreventMouseDown}
      closable={closable}
      onClose={onClose}
      style={{ margin: 5 }}
      className="flex items-center"
    >
      {label}
    </Tag>
  );
}
const BloodGroupSelect = ({ value, onChange }) => {
  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder="Select Blood Group"
      getPopupContainer={(trigger) => trigger.parentNode}
      allowClear
    >
      <Option value="A+">A+</Option>
      <Option value="B+">B+</Option>
      <Option value="O+">O+</Option>
      <Option value="A-">A-</Option>
      <Option value="B-">B-</Option>
      <Option value="O-">O-</Option>
      <Option value="AB+">AB+</Option>
      <Option value="AB-">AB-</Option>
    </Select>
  );
};

function InstructorSetting({ data }) {
  const { Option } = Select;
  const { confirm } = Modal;
  const { Title } = Typography;
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [form] = Form.useForm();
  const dateFormat = "YYYY-MM-DD";
  const [emailDisable, setEmailDisable] = useState(true);
  const [transportationCheckbox, setTransportationCheckbox] = useState(false);
  const [selectedZoneId, setSelectedZoneId] = useState(null);
  const [routeId, setRouteId] = useState(null);

  const billingZones = useQuery(["transport-billing-zones"], async () => {
    const res = await axios.get(
      `${serverUrl}/admin/transport-billing-zone/list`,
      {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        },
      }
    );
    return res.data?.result || [];
  });

  const selectedZone = useMemo(
    () => billingZones.data?.find((z) => z._id === selectedZoneId) || null,
    [billingZones.data, selectedZoneId]
  );

  const routes = useQuery(["school-routes"], async () => {
    const headers = { Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}` };
    const [v1Res, v2Res] = await Promise.all([
      axios.get(`${serverUrl}/routes`, { headers }),
      axios.get(`${serverUrl}/routes/v2`, { headers }),
    ]);
    const v1Data = v1Res.data?.result?.data || [];
    const v2Data = v2Res.data?.result?.data || [];
    return [
      ...v1Data.map((r) => ({ ...r, _version: "v1" })),
      ...v2Data.map((r) => ({ ...r, _version: "v2" })),
    ];
  });

  const routesDetail = useQuery(
    ["school-route-stops", routeId],
    async () => {
      const headers = { Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}` };
      const routeInList = (routes.data || []).find((r) => r._id === routeId);
      const url = routeInList?._version === "v2"
        ? `${serverUrl}/routes/v2/${routeId}`
        : `${serverUrl}/routes/${routeId}`;
      const res = await axios.get(url, { headers });
      return res.data?.result?.data?.route_map || [];
    },
    { enabled: !!routeId }
  );

  const fetchClasses = async () => {
    const res = await axios({
      method: "get",
      url: serverUrl + "/classes/",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data;
  };

  const classes = useQuery("classes", fetchClasses);

  // fetch departments
  async function fetchDepartments() {
    const response = await axios.get(serverUrl + "/department", {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });

    return response.data;
  }
  const departments = useQuery("departments", fetchDepartments);

  function showConfirm(values) {
    confirm({
      title: "Do you Want to change the details?",
      icon: <ExclamationCircleOutlined />,
      okText: "Yes",
      cancelText: "No",
      onOk() {
        updateProfile(values);
      },
      onCancel() {},
    });
  }

  const updateProfile = async (values) => {
    const payload = {
      first_name: values.first_name,
      last_name: values?.last_name,
      classes: values?.classes,
      title: values?.title,
      department: values?.department,
      is_transportation_required: transportationCheckbox,
      transport_zone_id: values.transport_zone_id || null,
      transport_destination_id: values?.transport_destination_id || null,
      route_id: values?.route_id || null,
      route_entry_point_id: values?.route_entry_point_id || null,
      // Plain calendar dates — a date object is serialised as UTC and would
      // shift IST midnight back a day.
      dob: values?.dob?.format ? values.dob.format(dateFormat) : values?.dob,
      employment_started_at: values?.employment_started_at?.format
        ? values.employment_started_at.format(dateFormat)
        : values?.employment_started_at,
      employment_ended_at: values?.employment_ended_at?.format
        ? values.employment_ended_at.format(dateFormat)
        : values?.employment_ended_at,
      aadhar: values?.aadhar,
      address: values?.address,
      blood_group: values?.blood_group,
    };
    const config = {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    };

    try {
      // Teacher profile fields.
      await axios.patch(
        serverUrl + "/teachers/" + data.teacher._id,
        payload,
        config,
      );

      // Account fields always go through /users/:id — /users/password/:id only
      // ever persists password/username and silently drops everything else.
      await axios.patch(
        serverUrl + "/users/" + data._id,
        {
          blocked: values.blocked,
          email: values.email,
          phone: values?.phone,
        },
        config,
      );

      // Password is optional and handled by its own endpoint.
      if (values.password) {
        await axios.patch(
          serverUrl + "/users/password/" + data?._id,
          { type: "password", password: values.password },
          config,
        );
        form.resetFields(["password"]);
      }

      message.success("Updated");
      queryClient.invalidateQueries(["instructor", data?._id]);
    } catch (err) {
      message.error(
        err?.response?.data?.message || "Failed to update instructor",
      );
    }
  };

  const confirmDelete = () => {
    confirm({
      title: "Do you Want to delete the instructor?",
      icon: <ExclamationCircleOutlined />,
      okText: "Yes",
      cancelText: "No",
      onOk() {
        deleteUser();
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const deleteUser = () => {
    axios({
      method: "delete",
      url: serverUrl + "/users/" + data?._id,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    }).then((res) => {
      message.success("Deleted");
      navigate(`/dashboard/admin/menu/instructor`);
    });
  };
  useEffect(() => {
    form.setFieldsValue({
      email: data?.email,
      phone: data?.phone,
      first_name: data?.teacher?.first_name,
      last_name: data?.teacher?.last_name,
      title: data?.teacher?.title,
      department: data?.teacher?.department?._id,
      classes: data?.teacher?.classes.map((s) => s._id),
      blocked: data?.blocked,
      dob: data?.teacher?.dob && moment(data?.teacher?.dob, dateFormat),
      employment_started_at:
        data?.teacher?.employment_started_at &&
        moment(data?.teacher?.employment_started_at, dateFormat),
      employment_ended_at:
        data?.teacher?.employment_ended_at &&
        moment(data?.teacher?.employment_ended_at, dateFormat),
      aadhar: data?.teacher?.aadhar,
      address: data?.teacher?.address,
      blood_group: data?.teacher?.blood_group,
      is_transportation_required: data?.is_transportation_required,
      transport_zone_id: data?.transport_zone_id?._id || data?.transport_zone_id || null,
      transport_destination_id: data?.transport_destination_id || null,
      route_id: data?.route_id?._id || data?.route_id || null,
      route_entry_point_id: data?.route_entry_point_id?._id || data?.route_entry_point_id || null,
    });
    setSelectedZoneId(data?.transport_zone_id?._id || data?.transport_zone_id || null);
    setRouteId(data?.route_id?._id || data?.route_id || null);
    setTransportationCheckbox(data?.is_transportation_required);
  }, [data, form]);
  return (
    <>
      <div className="pt-8">
        <div
          style={{ borderRadius: "10px", color: "#616161" }}
          className=" bg-white drop-shadow-md p-8 w-full "
        >
          {data && (
            <Form
              form={form}
              layout="vertical"
              name="basic"
              onFinish={showConfirm}
              autoComplete="off"
            >
              <div className="grid grid-cols-2 gap-x-4">
                <div className="flex flex-row items-center space-x-8">
                  <Form.Item
                    label="Email Address"
                    name="email"
                    className="w-full"
                  >
                    <Input
                      className="w-full"
                      type="email"
                      disabled={emailDisable}
                    />
                  </Form.Item>
                  <div
                    className="flex items-center justify-center p-2 bg-gray-300 rounded-full cursor-pointer"
                    onClick={() => setEmailDisable(false)}
                  >
                    <BsPencil />
                  </div>
                </div>
                <div className="flex flex-row items-center space-x-8 ">
                  <Form.Item
                    label="Password"
                    name="password"
                    className="w-full"
                    rules={[
                      {
                        min: 6,
                        message: "Password must be at least 6 characters long!",
                      },
                    ]}
                  >
                    <Input.Password placeholder="********" className="w-full" />
                  </Form.Item>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-x-4">
                <Form.Item
                  name="phone"
                  label="Phone"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your phone number",
                    },
                    {
                      pattern: /^[0-9]{10}$/,
                      message: "Please enter a valid 10-digit phone number!",
                    },
                  ]}
                  getValueFromEvent={(e) => e.target.value.slice(0, 10)}
                  className="w-full"
                >
                  <Input type="number" maxLength={10} min={0} {...numberInputGuard} />
                </Form.Item>
                <Form.Item
                  label="First Name"
                  name="first_name"
                  className="w-full"
                  rules={[
                    {
                      required: true,
                      message: "Please input your first name!",
                    },
                    {
                      message:
                        "Name must start with a letter and can only contain letters. Numbers and symbols are not allowed.",
                      validator: (_, value) => {
                        if (/^[a-zA-Z][a-zA-Z\s]*$/.test(value)) {
                          return Promise.resolve();
                        } else {
                          return Promise.reject(
                            "Name must start with a letter and can only contain letters. Numbers and symbols are not allowed.",
                          );
                        }
                      },
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Last Name"
                  name="last_name"
                  className="w-full"
                  rules={[
                    {
                      required: true,
                      message: "Please input your last name!",
                    },
                    {
                      message:
                        "Name must start with a letter and can only contain letters. Numbers and symbols are not allowed.",
                      validator: (_, value) => {
                        if (/^[a-zA-Z][a-zA-Z\s]*$/.test(value)) {
                          return Promise.resolve();
                        } else {
                          return Promise.reject(
                            "Name must start with a letter and can only contain letters. Numbers and symbols are not allowed.",
                          );
                        }
                      },
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item label="Title" name="title" className="w-full">
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Department"
                  name="department"
                  className="w-full"
                >
                  <Select
                    showSearch
                    showArrow
                    allowClear
                    placeholder="Select Department"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                    }
                    style={{
                      border: "6px",
                      backgroundColor: "#EBEBEB",
                    }}
                    className="w-full"
                  >
                    {departments.isSuccess &&
                      departments?.data?.map((data) => {
                        return (
                          <Option key={data._id} value={data._id}>
                            {data.name}
                          </Option>
                        );
                      })}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="aadhar"
                  label="Aadhar"
                  className="w-30"
                  rules={[
                    {
                      pattern: /^[0-9]{12}$/, // Updated regex pattern to match 12 digits
                      message: "Please enter a valid 12-digit Number!",
                    },
                  ]}
                  getValueFromEvent={(e) => e.target.value.slice(0, 12)}
                >
                  <Input maxLength={12} type="number" min={0} {...numberInputGuard} />
                </Form.Item>
                <Form.Item
                  name="dob"
                  label="Date Of Birth"
                  rules={[
                    {
                      required: true,
                      message: "Date of Birth  is required",
                    },
                  ]}
                  className="w-full"
                >
                  <DatePicker
                    format="DD-MM-YYYY"
                    placeholder="Please select your date of birth"
                    disabledDate={(current) =>
                      current && current > moment().endOf("day")
                    }
                    getPopupContainer={(trigger) => trigger.parentNode}
                    className="w-full"
                  />
                </Form.Item>
                <Form.Item
                  name="employment_started_at"
                  label="Employment Start Date"
                  className="w-full"
                >
                  <DatePicker
                    format="DD-MM-YYYY"
                    placeholder="Please select"
                    disabledDate={(current) =>
                      current && current > moment().endOf("day")
                    }
                    getPopupContainer={(trigger) => trigger.parentNode}
                    className="w-full"
                  />
                </Form.Item>
                <Form.Item
                  name="employment_ended_at"
                  label="Employment End Date"
                  className="w-full"
                >
                  <DatePicker
                    format="DD-MM-YYYY"
                    placeholder="Please select"
                    disabledDate={(current) =>
                      current && current > moment().endOf("day")
                    }
                    getPopupContainer={(trigger) => trigger.parentNode}
                    className="w-full"
                  />
                </Form.Item>
                <Form.Item
                  name="address"
                  label="Address"
                  className="w-30"
                  getValueFromEvent={(e) => e.target.value}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="blood_group"
                  label="Blood Group"
                  className="w-30"
                >
                  <BloodGroupSelect />
                </Form.Item>

                <div>
                  <div className="pb-2">Classes Allowed </div>
                  <Form.Item name="classes" className="w-full">
                    <Select
                      mode="multiple"
                      showArrow
                      allowClear
                      disabled={data.blocked}
                      tagRender={tagRender}
                      placeholder="Select Classes"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {classes.isSuccess &&
                        classes?.data
                          ?.filter(
                            (s) =>
                              !s.teacher ||
                              s.teacher._id === data?.teacher?._id,
                          )
                          .map((data) => {
                            return (
                              <Option key={data._id} value={data._id}>
                                {data.name}
                              </Option>
                            );
                          })}
                    </Select>
                  </Form.Item>
                </div>
              </div>
              <Title level={2}>Transportation</Title>
              <Form.Item
                name="is_transportation_required"
                valuePropName="checked"
              >
                <Checkbox
                  onChange={(e) => {
                    setTransportationCheckbox(e.target.checked);
                    form.resetFields(["transport_zone_id", "transport_destination_id", "route_id", "route_entry_point_id"]);
                    setSelectedZoneId(null);
                    setRouteId(null);
                  }}
                  checked={transportationCheckbox}
                >
                  Transportation require?
                </Checkbox>
              </Form.Item>
              {transportationCheckbox && (
                <div className="admission-form">
                  <Form.Item
                    label="Transport Zone"
                    name="transport_zone_id"
                    className="w-full"
                  >
                    <Select
                      showSearch
                      showArrow
                      placeholder="Select Zone"
                      className="bg-gray-300"
                      style={{ border: "6px", backgroundColor: "#EBEBEB" }}
                      getPopupContainer={(trigger) => trigger.parentNode}
                      onChange={(value) => {
                        setSelectedZoneId(value);
                        form.resetFields(["transport_destination_id"]);
                      }}
                    >
                      {billingZones?.isSuccess &&
                        billingZones?.data?.map((zone) => (
                          <Option key={zone._id} value={zone._id}>
                            {zone.name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="Destination"
                    name="transport_destination_id"
                    className="w-full"
                  >
                    <Select
                      showSearch
                      showArrow
                      placeholder="Select Destination"
                      className="w-full bg-gray-300"
                      style={{ border: "6px", backgroundColor: "#EBEBEB" }}
                      getPopupContainer={(trigger) => trigger.parentNode}
                      disabled={!selectedZoneId}
                    >
                      {selectedZone?.destinations?.map((dest) => (
                        <Option key={dest._id} value={dest._id}>
                          {dest.name} — ₹{Number(dest.amount).toLocaleString("en-IN")}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              )}
              {transportationCheckbox && (
                <div className="mt-4" style={{ borderTop: "1px solid #e8e8e8", paddingTop: 16 }}>
                  <div className="font-medium text-gray-600 mb-3" style={{ fontSize: 13 }}>Bus Tracking (Live Tracking App)</div>
                  <div className="grid grid-cols-2 gap-x-4">
                    <Form.Item label="Route" name="route_id" className="w-full">
                      <Select
                        showSearch
                        showArrow
                        allowClear
                        placeholder="Select Route"
                        className="w-full"
                        loading={routes.isLoading}
                        onChange={(value) => {
                          setRouteId(value || null);
                          form.resetFields(["route_entry_point_id"]);
                        }}
                      >
                        {(routes.data || []).map((route) => (
                          <Option key={route._id} value={route._id}>
                            {route.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item label="Entry Point" name="route_entry_point_id" className="w-full">
                      <Select
                        showSearch
                        showArrow
                        allowClear
                        placeholder={routeId ? "Select entry point" : "Select a route first"}
                        className="w-full"
                        disabled={!routeId}
                      >
                        {(routesDetail.data || []).map((stop) => (
                          <Option key={stop._id} value={stop._id}>
                            {stop.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                </div>
              )}

              <div>
                <div className="pt-4 pb-2">Instructor Status</div>
                <Form.Item className="w-96" name="blocked">
                  <Select
                    showSearch
                    showArrow
                    allowClear
                    placeholder="Instructor Status"
                    optionFilterProp="children"
                  >
                    <Option value={false} className="text-green-600">
                      Active
                    </Option>
                    <Option value={true} className="text-red-600">
                      Suspend
                    </Option>
                  </Select>
                </Form.Item>
              </div>

              <div className="flex items-center justify-between pt-10 ">
                <div>
                  <Button size="large" type="danger" onClick={confirmDelete}>
                    Delete
                  </Button>
                </div>
                <div className="flex flex-row space-x-4">
                  <Button
                    size="large"
                    type="dark"
                    onClick={() => {
                      form.resetFields();
                    }}
                  >
                    Cancel
                  </Button>

                  <Button
                    size="large"
                    type="primary"
                    htmlType="submit"
                    className="text-white"
                  >
                    Save Changes
                  </Button>
                </div>
              </div>
            </Form>
          )}
        </div>
      </div>
    </>
  );
}

export default InstructorSetting;




